var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-4"},[_c('v-sheet',{staticClass:"text-css text-start"},[_vm._v(" "+_vm._s(_vm.text))]),_c('v-sheet',{staticClass:"d-flex justify-center mt-4"},[_c('button',{staticClass:"btn",on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.buttonClose))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }